<template>

    <textarea class="textarea" :class="classes" :rows="rows" v-model="val" />

</template>

<style scoped lang="scss">

    .textarea {
        @include font-medium(13px);
        appearance: none;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 3px;
        box-sizing: border-box;
        color: $color-text;
        display: block;
        line-height: 1.6em;
        outline: none;
        padding: 15px;
        resize: none;
        transition: border-color .3s;
        width: 100%;
        &.resize {
            resize: both;
        }
        &:hover, &:focus {
            border-color: $color-text;
            color: $color-text;
        }
        &:disabled {
            background: $color-bg;
            border-color: $color-rule;
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        rows: {
            type: Number,
            default: 5,
        },
        resize: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            val: this.model,
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

    computed: {

        classes() {
            return {
                resize: this.resize,
            }
        },

    }

}

</script>
